import { z } from "zod";

export enum V2WorkflowType {
  INBOUND_REFERRAL_WF = "Inbound Referral WF",
  ORDERS_WF = "Orders WF",
  ORDERS_WF_NO_MATCH = "Orders WF (No Match)",
  ORDERS_WF_TEST_NOT_PERFORMED = "Orders WF (Test Not Performed)",
  CONSULT_REFERRALS_WF = "Consult/Referrals WF",
  EMAIL_FAX_EHR_WF = "Email + Fax + EHR WF",
  EMAIL_FAX_WF = "Email + Fax WF",
  EMAIL_EHR_WF = "Email + EHR WF",
  EHR_EMAIL_WF = "EHR + Email WF",
  FAX_WF = "Fax WF",
  NO_ROUTING_WF = "No Routing WF",
  LEAD_FORM_WF = "Lead Form WF",
  OUTGOING_REFERRALS_WF = "Outgoing Referrals WF",
  REFERRAL_REQUEST_WF = "Referral Request WF",
  REFERRAL_EMAIL_ONLY_WF = "Referral Email Only WF",
  SPECIAL_CASES = "Special Cases",
  STANDARD = "Standard",
  EHR_UPLOAD_WF = "EHR Upload WF",
  EHR_AND_EMAIL_WF = "EHR + Email WF",
  UPLOAD_AND_TASK_WF = "Upload + Task",
  TE_CREATION_WF = "TE Creation WF",
  SIGNATURE_TASK_WF = "Signature Task WF",
  EXTERNAL_ROUTING_WF = "External Routing WF",
  DME_ORDER_WF = "DME Order WF",
  PROCEDURE_SLEEP_WF = "Procedure Sleep WF",
  PRIOR_AUTHORIZATION_WF = "Prior Authorization WF",
  CLEARANCE_REQUEST_WF = "Clearance Request WF",
  ORDER_FROM_PHYSICIAN_WF = "Order From Physician WF",
  PRIOR_AUTHORIZATION_REFERRAL_RESPONSE_WF = "Prior Authorization Referral Response WF",
  REFERRAL_AUTHORIZATION_WF = "Referral Authorization WF",
  PHARMACY_RELATED_WF = "Pharmacy Related WF",
  RECEIVING_PROVIDER_WF = "Receiving Provider WF",
  SFTP_UPLOAD_WF = "SFTP Upload WF",
  STANDARD_WITH_PCP_LOOKUP = "Standard (PCP Lookup)",
  STANDARD_SKIP_CC = "Standard (Skip CC)",
  OUTGOING_REFERRALS_WF_WITH_REFERRAL_ATTACH = "Outgoing Referrals WF (Referral Attach)",
  FCC_DOC_ROUTING_WF = "FCC Doc Routing WF",
  FCC_VA_MILITARY_FORWARD_WF = "FCC VA Military Forward WF",
  FCC_CLINICAL_FORM_WF = "FCC Clinical Form WF",
  FCC_SPECIALTY_FORWARD_WF = "FCC Specialty Forward WF",
  TCO_APEX_FORWARD_WF = "TCO Apex Forward WF",
  TCO_EXTERNAL_IMAGING_WF = "TCO External Imaging WF",
  INBOUND_REFERRAL_WF_LITE = "Inbound Referral WF (Lite)",
  SPECIAL_CASES_LITE = "Special Cases (Lite)",
  STANDARD_LITE = "Standard (Lite)",
  STANDARD_WITH_PCP_LOOKUP_LITE = "Standard (PCP Lookup, Lite)",
  REFERRAL_REQUEST_WF_LITE = "Referral Request WF (Lite)",
  ORDERS_WF_NO_MATCH_LITE = "Orders WF No Match (Lite)",
  ORDERS_WF_MATCH_ONLY_LITE = "Orders WF Match Only (Lite)",
  TE_CREATION_WF_LITE = "TE Creation WF (Lite)",
  INSURANCE_COMMUNICATION_WF = "Insurance Communication WF",
  SIGNED_PLAN_OF_CARE_WF = "Signed Plan of Care WF",
}

export const v2WorkflowTypeSchema = z.nativeEnum(V2WorkflowType);
